import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  CSSProperties,
} from "react";

import {
  Expression,
  GridData,
  GridDataOptions,
  GridProps,
  Pager,
  Sorter,
} from "./schema";
import {
  getDataSource,
  getDictionaryMapper,
  getGridData,
  getPagination,
} from "../../../../component/DataList/util";
import {
  Button,
  Icon,
  List,
  Checkbox,
  Result,
  SearchBar,
  InputItem,
  Toast,
  DatePicker
} from "antd-mobile";
import { Popover, Space , Dialog } from "antd-mobile-v5";
import { DownOutline, RightOutline, UpOutline } from "antd-mobile-icons";
import DictionarySelect from "../../../../component/CheckBoxItem";
import instance from "../../../../util/axios";
import moment from "moment";

const { Item } = List;
const Brief = Item.Brief;
const CheckboxItem = Checkbox.CheckboxItem;
interface InputFields {
  uuid: string;
  quantity?: string;
  pieces?: string;
}
const WorkDataList = forwardRef(
  (
    {
      url,
      pagination,
      returning,
      isCutting,
      descriptions,
      useLegacyAPI,
      expressions,
      sorter,
      onComplete,
      onClickRow,
      rowSelectionType,
      pageSize = 10,
      step = 1,
      homeParams,
    }: GridProps,
    ref: any
  ) => {
    const searchFormRef = useRef<{ [key: string]: string }>({});
    const [innerPagination, setInnerPagination] = useState<any>({});
    const [data, setData] = useState<any[]>([]);
    const [dictionary, setDictionary] = useState({});
    const [formattedData, setFormattedData] = useState<any[]>([]);
    const [pageIndex, setPageIndex] = useState<number>(1);
    // const [keywordType, setKeywordType] = useState<
    //   | "orderNo"
    //   | "dealerName"
    //   | "skuName"
    //   | "gear"
    //   | "gearModel"
    //   | "color"
    //   | "formulaName"
    // >("orderNo");
    // const [typeArr] = useState<any[]>([
    //   { key: "orderNo", text: "批号" },
    //   { key: "dealerName", text: "客户名称" },
    //   { key: "skuName", text: "产品" },
    //   { key: "gear", text: "拍档方式" },
    //   { key: "gearModel", text: "主管/档管规格" },
    //   { key: "color", text: "表面处理" },
    //   { key: "formulaName", text: "图号" },
    // ]);
    const [keyword, setKeyword] = useState<string>();
    const [keyword1, setKeyword1] = useState<string>();
    const [barWord, setBarWord] = useState<string>();
    const [barWord1, setBarWord1] = useState<string>();
    const [total, setTotal] = useState(0);
    const [submitForm, setSubmitForm] = useState<{
      quantity?: string;
      pieces?: string;
    }>({});
    const filledStyle: CSSProperties = {
      color: "#FD5A5F",
    };
    const notFilledStyle: CSSProperties = {
      color: "black",
    };
    const [inputFields, setInputFields] = useState<InputFields[]>([]);
    //新增
    const [completionHome, setCompletionHome] = useState<any>({
      expand: false,
      isReturning: "",
      isOther: "", //车间帮工
      workshopId: "",
      procedureId: "",
      remarkId: "",
      staffId: "",
      orderCalType: "",
      useGroup: "",
      groupId: "",
      joinedStaffsId: "",
      workDate:"",
    });
    const [procedureFilter, setProcedureFilter] = useState<string>("");
    const [remarkFilter, setRemarkFilter] = useState<string>("");
    const [staffFilter, setStaffFilter] = useState<string>("");
    const [groupFilter, setGroupFilter] = useState<string>("");
    /**
     * 仅查询数据
     * @param pager
     * @param currentSorter
     */
    const getData = useCallback(
      async function getData(
        pager?: Pager,
        currentSorter?: Sorter,
        keyword?: string
      ): Promise<GridData> {
        const options: GridDataOptions = {
          // url: keyword ? `${url}&${keywordType}=${keyword}` : url,
          url,
          dictionaryMapper: getDictionaryMapper(descriptions),
          pagination: pagination !== false,
          pager: pager,
          sorter: currentSorter && currentSorter.order ? currentSorter : sorter,
          // searchForm: searchFormRef.current,
          searchForm: { param: keyword || "" },
          fuzzySearch: "",
          // fuzzySearch: keyword,
          innerDescriptions: descriptions,
        };
        if (useLegacyAPI) {
          options.expressions = expressions || [
            new Expression("数量", "count(1)"),
          ];
        }
        return await getGridData(options);
      },
      [descriptions, expressions, pagination, sorter, url, useLegacyAPI]
    );

    /**
     * 加载数据
     * @param pager
     * @param currentSorter
     */
    const loadData = useCallback(
      async function loadData(
        pager?: Pager,
        currentSorter?: Sorter,
        searchKeyword?: string
      ) {
        const gridData = await getData(
          pager,
          currentSorter,
          searchKeyword ? searchKeyword : keyword
        );
        gridData &&
          gridData.data &&
          gridData.data.length > 0 &&
          gridData.data.forEach((item, index) => {
            if (!item.uuid) item.uuid = (+new Date()).toString() + index;
          });
        if (gridData) {
          if (useLegacyAPI) {
            setInnerPagination(
              getPagination(gridData, gridData.expressions!["数量"])
            );
          } else {
            setInnerPagination(getPagination(gridData, gridData?.total || 10));
          }
          setData((prevState) => {
            if (pager?.pageIndex === 1) {
              return gridData.data;
            }
            return [...prevState, gridData.data];
          });
          setDictionary((prevState: { [key: string]: unknown[] }) => {
            if (pager?.pageIndex === 1) {
              return gridData.dictionary;
            }

            const result: { [key: string]: unknown[] } = {};
            for (const prop in prevState) {
              if (!Object.prototype.hasOwnProperty.call(prevState, prop)) {
                continue;
              }
              result[prop] = [...prevState[prop]];
              if (gridData.dictionary[prop]) {
                result[prop] = [...result[prop], ...gridData.dictionary[prop]];
              }
            }
            return result;
          });
          const currentFormattedData = getDataSource(gridData, descriptions);
          onComplete?.(currentFormattedData);
          gridData.data.forEach((element: any) => {
            delete element.children;
          });
          const formdata = getDataSource(gridData, descriptions);
          /*const copy = JSON.parse(JSON.stringify(inputFields))
          console.log(JSON.stringify(copy));
          console.log(JSON.stringify(inputFields));
          formdata.forEach((item) => {
            const index = inputFields.findIndex((it) => it.uuid === item.uuid);
            if (index === -1) {
              copy.push({
                uuid: item.uuid,
                quantity: "",
                pieces: ""
              });
            }
          });
          setInputFields(copy);*/
          setFormattedData((prevState) => {
            if (pager?.pageIndex === 1) {
              return formdata;
            }

            return [...prevState, ...formdata];
          });
        }
      },
      [onComplete, useLegacyAPI, keyword]
    );

    useEffect(() => {
      loadData({ pageIndex, pageSize: pageSize }).then();
    }, [loadData, pageIndex, pageSize]);

    // 选中行数据
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    useImperativeHandle(ref, () => ({
      getCheckedItem() {
        return selectedRows;
      },
      clearCheckedItem() {
        setSelectedRows([]);
      },
      getcompletionHome() {
        return completionHome;
      },
    }));
    useEffect(() => {
      instance.get(`/erp/workshop/getWorkshopDeptByUser`).then((resp) => {
        if (resp.data.Status === "1" && resp.data.Data) {
          if (resp.data.Data.workshopId) {
            setProcedureFilter(
              " workshopId like '" + resp.data.Data.workshopId + "'"
            );
            setGroupFilter(" workshopId='" + resp.data.Data.workshopId + "'");
          }
          if (resp.data.Data.departmentIds) {
            setStaffFilter(
              " find_in_set(departmentId,'" +
                resp.data.Data.departmentIds +
                "')>0"
            );
          }
        }
      });
    }, []);
    useEffect(() => {
      setCompletionHome({
        expand: false,
        isReturning: homeParams?.isReturning,
        isOther: homeParams?.isOther, //车间帮工
        workshopId: homeParams?.workshopId,
        procedureId: homeParams?.procedureId,
        remarkId: homeParams?.remarkId,
        staffId: homeParams?.staffId,
        orderCalType: homeParams?.orderCalType,
        useGroup: homeParams?.useGroup,
        groupId: homeParams?.groupId,
        joinedStaffsId: homeParams?.joinedStaffsId,
        workDate: homeParams?.workDate,
        submit: homeParams?.submitId,
      });
    }, [homeParams]);

    return step === 1 ? (
      <>
        <List>
          <div style={{ width: "100%", display: "inline-flex" }}>
            {/* <Popover.Menu
              actions={typeArr}
              placement="bottom-start"
              onAction={(node: any) => setKeywordType(node.key)}
              trigger="click"
            >
              <div style={{ display: "flex", alignItems: "center", width: 82 }}>
                <div>
                  {
                    typeArr.filter((it: any) => it.key === keywordType)?.[0]
                      ?.text
                  }
                </div>
                <RightOutline />
              </div>
            </Popover.Menu> */}
            <SearchBar
              style={{ width: "85%", height: 50, fontSize: 16 }}
              value={barWord}
              key="1"
              placeholder="多个条件时以逗号分割"
              maxLength={20}
              onChange={(value) => {
                setBarWord(value);
                // setPageIndex(1);
                //loadData({ pageIndex: 1, pageSize }, undefined, value).then();
              }}
            />
            <Button
              style={{ width: "15%", height: 50, fontSize: 16 }}
              onClick={() => {
                setKeyword(barWord);
                setPageIndex(1);
              }}
            >
              查询
            </Button>
          </div>
          {rowSelectionType === "checkbox"
            ? formattedData.map((item, i) => (
                <CheckboxItem
                  style={{ marginLeft: 12 }}
                  key={item.uuid}
                  checked={selectedRows.some(
                    (selectedItem) => selectedItem.uuid === item.uuid
                  )}
                  onChange={(e: { target: { checked: any } }) => {
                    const copy = JSON.parse(JSON.stringify(selectedRows));
                    const inputIndex = inputFields.findIndex(
                      (it) => it.uuid === item.uuid
                    );
                    if (e.target.checked) {
                      // 选中数据时 要同步对应uuid的工作量
                      if (inputIndex === -1) {
                        item.quantity = "";
                        item.pieces = "";
                      } else {
                        item.quantity = inputFields[inputIndex].quantity;
                        item.pieces = inputFields[inputIndex].pieces;
                      }
                      if (
                        (item.quantity === "" ||
                          item.quantity === null ||
                          item.quantity === undefined) &&
                        (item.pieces === "" ||
                          item.pieces === null ||
                          item.pieces === undefined)
                      ) {
                        Toast.fail("请填写数量后再选择！");
                        return;
                      }
                      copy.push(item);
                    } else {
                      const index = copy.findIndex(
                        (a: any) => a.uuid === item.uuid
                      );
                      copy.splice(index, 1); // 删除取消的选项
                      item.quantity = "";
                      item.pieces = "";
                    }
                    setSelectedRows(copy);
                  }}
                >
                  {
                    <Item wrap align="top" multipleLine>
                      <Brief
                        style={
                          item["isFilled"] == "1" ? filledStyle : notFilledStyle
                        }
                      >
                        {descriptions[0].fieldShowName!}：
                        {item[descriptions[0].fieldName!]}
                        {descriptions
                          .slice(1, descriptions.length)
                          .map((desc) => (
                            <div
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-all",
                                overflow: "hidden",
                              }}
                            >
                              {`${desc.fieldShowName}: ${
                                item[desc.fieldName!]
                              }`}
                            </div>
                          ))}
                      </Brief>
                      {!returning && isCutting == "true" && (
                        <>
                          <div style={{ marginLeft: -16 }}>
                            <InputItem
                              style={{ marginLeft: -6, textAlign: "left" }}
                              id={item.uuid}
                              min={0}
                              type={"digit"}
                              placeholder={"请填写"}
                              value={
                                inputFields[
                                  inputFields.findIndex(
                                    (it) => it.uuid === item.uuid
                                  )
                                ]?.quantity
                              }
                              onChange={(value) => {
                                // 输入框填写工作量时 要同步到已选项
                                const copy = JSON.parse(
                                  JSON.stringify(inputFields)
                                );
                                const itemIndex = copy.findIndex(
                                  (it: any) => it.uuid === item.uuid
                                );
                                if (itemIndex === -1) {
                                  copy.push({
                                    uuid: item.uuid,
                                    quantity: value,
                                    pieces: "",
                                  });
                                } else {
                                  copy[itemIndex].quantity = value;
                                }

                                setInputFields(copy);
                                const copySelectedRows = JSON.parse(
                                  JSON.stringify(selectedRows)
                                );
                                copySelectedRows.forEach((ite: any) => {
                                  const index = copy.findIndex(
                                    (it: any) => it.uuid === ite.uuid
                                  );
                                  ite.quantity = copy[index].quantity;
                                  ite.pieces = copy[index].pieces;
                                });
                                setSelectedRows(copySelectedRows);
                              }}
                            >
                              本次下料数量:
                            </InputItem>
                          </div>
                        </>
                      )}
                      {!returning && isCutting == "false" && (
                        <>
                          <div style={{ marginLeft: -16 }}>
                            <InputItem
                              style={{ marginLeft: -6, textAlign: "left" }}
                              id={item.uuid}
                              min={0}
                              type={"digit"}
                              placeholder={"请填写"}
                              value={
                                inputFields[
                                  inputFields.findIndex(
                                    (it) => it.uuid === item.uuid
                                  )
                                ]?.quantity
                              }
                              onChange={(value) => {
                                // 输入框填写工作量时 要同步到已选项
                                const copy = JSON.parse(
                                  JSON.stringify(inputFields)
                                );
                                const itemIndex = copy.findIndex(
                                  (it: any) => it.uuid === item.uuid
                                );
                                if (itemIndex === -1) {
                                  copy.push({
                                    uuid: item.uuid,
                                    quantity: value,
                                    pieces: "",
                                  });
                                } else {
                                  copy[itemIndex].quantity = value;
                                }

                                setInputFields(copy);
                                const copySelectedRows = JSON.parse(
                                  JSON.stringify(selectedRows)
                                );
                                copySelectedRows.forEach((ite: any) => {
                                  const index = copy.findIndex(
                                    (it: any) => it.uuid === ite.uuid
                                  );
                                  ite.quantity = copy[index].quantity;
                                  ite.pieces = copy[index].pieces;
                                });
                                setSelectedRows(copySelectedRows);
                              }}
                            >
                              本次组数:
                            </InputItem>
                            <InputItem
                              style={{ marginLeft: -6, textAlign: "left" }}
                              id={item.uuid + "pieces"}
                              min={0}
                              type={"digit"}
                              disabled={!item.totalPieces}
                              placeholder={"请填写"}
                              value={
                                inputFields[
                                  inputFields.findIndex(
                                    (it) => it.uuid === item.uuid
                                  )
                                ]?.pieces
                              }
                              onChange={(value) => {
                                // 输入框填写工作量时 要同步到已选项
                                const copy = JSON.parse(
                                  JSON.stringify(inputFields)
                                );
                                const itemIndex = copy.findIndex(
                                  (it: any) => it.uuid === item.uuid
                                );
                                if (itemIndex === -1) {
                                  copy.push({
                                    uuid: item.uuid,
                                    quantity: "",
                                    pieces: value,
                                  });
                                } else {
                                  copy[itemIndex].pieces = value;
                                }

                                setInputFields(copy);
                                const copySelectedRows = JSON.parse(
                                  JSON.stringify(selectedRows)
                                );
                                copySelectedRows.forEach((ite: any) => {
                                  const index = copy.findIndex(
                                    (it: any) => it.uuid === ite.uuid
                                  );
                                  ite.quantity = copy[index].quantity;
                                  ite.pieces = copy[index].pieces;
                                });
                                setSelectedRows(copySelectedRows);
                              }}
                            >
                              本次柱/档数:
                            </InputItem>
                          </div>
                        </>
                      )}
                      {returning && (
                        <>
                          <div style={{ marginLeft: -16 }}>
                            <InputItem
                              style={{ marginLeft: -6, textAlign: "left" }}
                              id={item.uuid}
                              min={0}
                              type={"digit"}
                              placeholder={"请填写"}
                              value={
                                inputFields[
                                  inputFields.findIndex(
                                    (it) => it.uuid === item.uuid
                                  )
                                ]?.quantity
                              }
                              onChange={(value) => {
                                // 输入框填写工作量时 要同步到已选项
                                const copy = JSON.parse(
                                  JSON.stringify(inputFields)
                                );
                                const itemIndex = copy.findIndex(
                                  (it: any) => it.uuid === item.uuid
                                );
                                if (itemIndex === -1) {
                                  copy.push({
                                    uuid: item.uuid,
                                    quantity: value,
                                    pieces: "",
                                  });
                                } else {
                                  copy[itemIndex].quantity = value;
                                }

                                setInputFields(copy);
                                const copySelectedRows = JSON.parse(
                                  JSON.stringify(selectedRows)
                                );
                                copySelectedRows.forEach((ite: any) => {
                                  const index = copy.findIndex(
                                    (it: any) => it.uuid === ite.uuid
                                  );
                                  ite.quantity = copy[index].quantity;
                                  ite.pieces = copy[index].pieces;
                                });
                                setSelectedRows(copySelectedRows);
                              }}
                            >
                              (返修)本次组数:
                            </InputItem>
                            <InputItem
                              style={{ marginLeft: -6, textAlign: "left" }}
                              id={item.uuid + "pieces"}
                              min={0}
                              type={"digit"}
                              placeholder={"请填写"}
                              value={
                                inputFields[
                                  inputFields.findIndex(
                                    (it) => it.uuid === item.uuid
                                  )
                                ]?.pieces
                              }
                              onChange={(value) => {
                                // 输入框填写工作量时 要同步到已选项
                                const copy = JSON.parse(
                                  JSON.stringify(inputFields)
                                );
                                const itemIndex = copy.findIndex(
                                  (it: any) => it.uuid === item.uuid
                                );
                                if (itemIndex === -1) {
                                  copy.push({
                                    uuid: item.uuid,
                                    quantity: "",
                                    pieces: value,
                                  });
                                } else {
                                  copy[itemIndex].pieces = value;
                                }

                                setInputFields(copy);
                                const copySelectedRows = JSON.parse(
                                  JSON.stringify(selectedRows)
                                );
                                copySelectedRows.forEach((ite: any) => {
                                  const index = copy.findIndex(
                                    (it: any) => it.uuid === ite.uuid
                                  );
                                  ite.quantity = copy[index].quantity;
                                  ite.pieces = copy[index].pieces;
                                });
                                setSelectedRows(copySelectedRows);
                              }}
                            >
                              (返修)本次柱/档数:
                            </InputItem>
                          </div>
                        </>
                      )}
                    </Item>
                  }
                </CheckboxItem>
              ))
            : formattedData.map((item) => (
                <Item
                  wrap
                  align="top"
                  multipleLine
                  onClick={() => {
                    if (onClickRow) {
                      onClickRow(item);
                    } else {
                      return;
                    }
                  }}
                >
                  {item[descriptions[0].fieldName!]}
                  <Brief>
                    {descriptions.slice(1, descriptions.length).map((desc) => (
                      <div>{`${desc.fieldShowName}: ${
                        item[desc.fieldName!]
                      }`}</div>
                    ))}
                  </Brief>
                </Item>
              ))}
        </List>
        {formattedData.length >= innerPagination.total &&
          formattedData.length === 0 && (
            <Button style={{ marginBottom: "50px" }}></Button>
          )}
        {formattedData.length < innerPagination.total && (
          <Button
            style={{ color: "#00b578", marginBottom: "50px" }}
            onClick={() => {
              setPageIndex((prevState) => prevState + 1);
            }}
          >
            点击加载更多
          </Button>
        )}
        {formattedData.length === 0 && (
          <Result
            style={{
              height: "calc(100vh - 136px)",
            }}
            img={
              <Icon
                type="cross-circle-o"
                style={{
                  width: 60,
                  height: 60,
                  color: "#1890ff",
                }}
              />
            }
            title="暂无数据"
          />
        )}
      </>
    ) : (
      <>
        <List>
          <div style={{ width: "100%", display: "inline-flex" }}>
            <SearchBar
              style={{ width: "85%", height: 50, fontSize: 16 }}
              value={barWord1}
              key="2"
              placeholder="Search"
              maxLength={20}
              onChange={(value) => {
                setBarWord1(value);
              }}
            />
            <Button
              style={{ width: "15%", height: 50, fontSize: 16 }}
              onClick={() => {
                setKeyword1(barWord1);
              }}
            >
              查询
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: 16,
              padding: "16px",
              paddingBottom: 0,
            }}
          >
            <div style={{ marginBottom: 4 }}>填报主信息</div>
            {completionHome?.expand ? (
              <UpOutline
                onClick={() => {
                  setCompletionHome((prevState: any) => ({
                    ...prevState,
                    expand: false,
                  }));
                }}
              />
            ) : (
              <DownOutline
                onClick={() => {
                  setCompletionHome((prevState: any) => ({
                    ...prevState,
                    expand: true,
                  }));
                }}
              />
            )}
          </div>
         
          {completionHome?.expand && (
            <div>
              <List>
                <DictionarySelect
                  title={"返修填报"}
                  multiple={false}
                  disabled={true}
                  dictionary={"dict_order_free_bool"}
                  value={completionHome.isReturning}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      isReturning: value,
                    }));
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"车间帮工"}
                  multiple={false}
                  disabled={true}
                  dictionary={"dict_order_free_bool"}
                  value={completionHome.isOther}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      isOther: value,
                    }));
                  }}
                />
              </List>
              {completionHome.isOther === "1" && (
                <List>
                  <DictionarySelect
                    title={"选择车间"}
                    multiple={false}
                    disabled={true}
                    dictionary={"erp_workshop"}
                    value={completionHome.workshopId}
                    onChange={(value) => {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        workshopId: value,
                      }));
                      setProcedureFilter(" workshopId like '" + value + "'");
                    }}
                  />
                </List>
              )}
              <List>
                <DictionarySelect
                  title={"工序"}
                  multiple={false}
                  disabled={true}
                  dictionary={"erp_procedure"}
                  originFilter={procedureFilter}
                  value={completionHome.procedureId}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      procedureId: value,
                    }));
                    instance
                      .post(`/erp/procedure/getRemarkIdsByProcedureId`, {
                        procedureId: value,
                      })
                      .then((resp) => {
                        if (resp.data.Status === "1" && resp.data.Data) {
                          setRemarkFilter(
                            " find_in_set(uuid,'" + resp.data.Data + "')>0"
                          );
                        }
                      });
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"生产产品"}
                  disabled={true}
                  multiple={false}
                  dictionary={"erp_remark_product"}
                  originFilter={remarkFilter}
                  value={completionHome.remarkId}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      remarkId: value,
                    }));
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"员工"}
                  multiple={false}
                  disabled={true}
                  dictionary={"base_staff"}
                  originFilter={staffFilter}
                  value={completionHome.staffId}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      staffId: value,
                    }));
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"类型"}
                  multiple={false}
                  disabled={true}
                  dictionary={"dict_order_production_cal_type"}
                  value={completionHome.orderCalType}
                  onChange={(value) => {
                    if (value !== "2") {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        orderCalType: value,
                        useGroup: "",
                        groupId: "",
                        joinedStaffsId: "",
                      }));
                    } else {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        orderCalType: value,
                      }));
                    }
                  }}
                />
              </List>
              <List>
              <DatePicker
                mode="date"
                title="选择日期"
                value={completionHome.workDate ? new Date(completionHome.workDate) : undefined}
                onChange={(value: any) =>
                  setCompletionHome((prevState:any) => ({
                    ...prevState,
                    workDate: moment(value).format("YYYY-MM-DD"),
                  }))
                }>
                <List.Item arrow="horizontal">
                工作日期
                </List.Item>
              </DatePicker>
              </List>

              <List>
                <DictionarySelect
                  title={"使用已有组别"}
                  multiple={false}
                  // disabled={completionHome.orderCalType !== "2"}
                  disabled={true}
                  dictionary={"dict_order_free_bool"}
                  value={completionHome.useGroup}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      useGroup: value,
                    }));

                    if (value !== "2") {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        useGroup: value,
                        groupId: "",
                      }));
                    } else {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        useGroup: value,
                      }));
                    }
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"选择组名称"}
                  multiple={false}
                  dictionary={"erp_work_group"}
                  originFilter={groupFilter}
                  // disabled={completionHome.orderCalType !== "2" || completionHome.useGroup !== "1"}
                  disabled={true}
                  value={completionHome.groupId}
                  onChange={async (value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      groupId: value,
                    }));
                    if (value) {
                      const resp = await instance.post(
                        `/erp/sku/workshop/getWorkGroupById`,
                        { uuid: value }
                      );
                      if (resp.data.Status === "1" && resp.data.Data) {
                        setCompletionHome((prevState: any) => ({
                          ...prevState,
                          joinedStaffsId: resp.data.Data.staffIds || "",
                        }));
                      }
                    }
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"参与员工"}
                  multiple={true}
                  // disabled={completionHome.orderCalType !== "2"}
                  disabled={true}
                  dictionary={"base_staff"}
                  originFilter={staffFilter}
                  value={completionHome.joinedStaffsId}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      joinedStaffsId: value,
                    }));
                  }}
                />
              </List>
            </div>
          )}
          {selectedRows
            ?.filter((items) => {
              let flag = false;
              if (keyword1) {
                if (items?.orderNo?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.dealerName?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.skuName?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.gear?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.gearModel?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.color?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.formulaName?.includes(keyword1)) {
                  flag = true;
                }
              } else {
                flag = true;
              }
              return flag;
            })
            .map((item, i) => (
              <CheckboxItem
                style={{ marginLeft: 12 }}
                key={item.uuid}
                checked={selectedRows.some(
                  (selectedItem) => selectedItem.uuid === item.uuid
                )}
                onChange={(e: { target: { checked: any } }) => {
                  Dialog.confirm({
                    content: "确定要删除该条数据吗？",
                    onConfirm: () => {
                      const copy = JSON.parse(JSON.stringify(selectedRows));
                      const inputIndex = inputFields.findIndex(
                        (it) => it.uuid === item.uuid
                      );
                      if (e.target.checked) {
                        // 选中数据时 要同步对应uuid的工作量
                        if (inputIndex === -1) {
                          item.quantity = "";
                          item.pieces = "";
                        } else {
                          item.quantity = inputFields[inputIndex].quantity;
                          item.pieces = inputFields[inputIndex].pieces;
                        }
                        if (
                          (item.quantity === "" ||
                            item.quantity === null ||
                            item.quantity === undefined) &&
                          (item.pieces === "" ||
                            item.pieces === null ||
                            item.pieces === undefined)
                        ) {
                          Toast.fail("请填写数量后再选择！");
                          return;
                        }
                        copy.push(item);
                      } else {
                        const index = copy.findIndex(
                          (a: any) => a.uuid === item.uuid
                        );
                        copy.splice(index, 1); // 删除取消的选项
                        item.quantity = "";
                        item.pieces = "";
                      }
                      setSelectedRows(copy);
                    },
                  });
                }}
              >
                <Item wrap align="top" multipleLine key={item?.uuid}>
                  <Brief
                    style={
                      item["isFilled"] == "1" ? filledStyle : notFilledStyle
                    }
                  >
                    {descriptions[0].fieldShowName!}：
                    {item[descriptions[0].fieldName!]}
                    {descriptions.slice(1, descriptions.length).map((desc) => (
                      <div
                        style={{
                          whiteSpace: "normal",
                          wordBreak: "break-all",
                          overflow: "hidden",
                        }}
                      >
                        {`${desc.fieldShowName}: ${item[desc.fieldName!]}`}
                      </div>
                    ))}
                  </Brief>
                  {!returning && isCutting == "true" && (
                    <>
                      <div style={{ marginLeft: -16 }}>
                        <InputItem
                          style={{ marginLeft: -6, textAlign: "left" }}
                          id={item.uuid}
                          min={0}
                          type={"digit"}
                          placeholder={"请填写"}
                          value={
                            inputFields[
                              inputFields.findIndex(
                                (it) => it.uuid === item.uuid
                              )
                            ]?.quantity
                          }
                          onChange={(value) => {
                            // 输入框填写工作量时 要同步到已选项
                            const copy = JSON.parse(
                              JSON.stringify(inputFields)
                            );
                            const itemIndex = copy.findIndex(
                              (it: any) => it.uuid === item.uuid
                            );
                            if (itemIndex === -1) {
                              copy.push({
                                uuid: item.uuid,
                                quantity: value,
                                pieces: "",
                              });
                            } else {
                              copy[itemIndex].quantity = value;
                            }

                            setInputFields(copy);
                            const copySelectedRows = JSON.parse(
                              JSON.stringify(selectedRows)
                            );
                            copySelectedRows.forEach((ite: any) => {
                              const index = copy.findIndex(
                                (it: any) => it.uuid === ite.uuid
                              );
                              ite.quantity = copy[index].quantity;
                              ite.pieces = copy[index].pieces;
                            });
                            setSelectedRows(copySelectedRows);
                          }}
                        >
                          本次下料数量:
                        </InputItem>
                      </div>
                    </>
                  )}
                  {!returning && isCutting == "false" && (
                    <>
                      <div style={{ marginLeft: -16 }}>
                        <InputItem
                          style={{ marginLeft: -6, textAlign: "left" }}
                          id={item.uuid}
                          min={0}
                          type={"digit"}
                          placeholder={"请填写"}
                          value={
                            inputFields[
                              inputFields.findIndex(
                                (it) => it.uuid === item.uuid
                              )
                            ]?.quantity
                          }
                          onChange={(value) => {
                            // 输入框填写工作量时 要同步到已选项
                            const copy = JSON.parse(
                              JSON.stringify(inputFields)
                            );
                            const itemIndex = copy.findIndex(
                              (it: any) => it.uuid === item.uuid
                            );
                            if (itemIndex === -1) {
                              copy.push({
                                uuid: item.uuid,
                                quantity: value,
                                pieces: "",
                              });
                            } else {
                              copy[itemIndex].quantity = value;
                            }

                            setInputFields(copy);
                            const copySelectedRows = JSON.parse(
                              JSON.stringify(selectedRows)
                            );
                            copySelectedRows.forEach((ite: any) => {
                              const index = copy.findIndex(
                                (it: any) => it.uuid === ite.uuid
                              );
                              ite.quantity = copy[index].quantity;
                              ite.pieces = copy[index].pieces;
                            });
                            setSelectedRows(copySelectedRows);
                          }}
                        >
                          本次组数:
                        </InputItem>
                        <InputItem
                          style={{ marginLeft: -6, textAlign: "left" }}
                          id={item.uuid + "pieces"}
                          min={0}
                          type={"digit"}
                          disabled={!item.totalPieces}
                          placeholder={"请填写"}
                          value={
                            inputFields[
                              inputFields.findIndex(
                                (it) => it.uuid === item.uuid
                              )
                            ]?.pieces
                          }
                          onChange={(value) => {
                            // 输入框填写工作量时 要同步到已选项
                            const copy = JSON.parse(
                              JSON.stringify(inputFields)
                            );
                            const itemIndex = copy.findIndex(
                              (it: any) => it.uuid === item.uuid
                            );
                            if (itemIndex === -1) {
                              copy.push({
                                uuid: item.uuid,
                                quantity: "",
                                pieces: value,
                              });
                            } else {
                              copy[itemIndex].pieces = value;
                            }

                            setInputFields(copy);
                            const copySelectedRows = JSON.parse(
                              JSON.stringify(selectedRows)
                            );
                            copySelectedRows.forEach((ite: any) => {
                              const index = copy.findIndex(
                                (it: any) => it.uuid === ite.uuid
                              );
                              ite.quantity = copy[index].quantity;
                              ite.pieces = copy[index].pieces;
                            });
                            setSelectedRows(copySelectedRows);
                          }}
                        >
                          本次柱/档数:
                        </InputItem>
                      </div>
                    </>
                  )}
                  {returning && (
                    <>
                      <div style={{ marginLeft: -16 }}>
                        <InputItem
                          style={{ marginLeft: -6, textAlign: "left" }}
                          id={item.uuid}
                          min={0}
                          type={"digit"}
                          placeholder={"请填写"}
                          value={
                            inputFields[
                              inputFields.findIndex(
                                (it) => it.uuid === item.uuid
                              )
                            ]?.quantity
                          }
                          onChange={(value) => {
                            // 输入框填写工作量时 要同步到已选项
                            const copy = JSON.parse(
                              JSON.stringify(inputFields)
                            );
                            const itemIndex = copy.findIndex(
                              (it: any) => it.uuid === item.uuid
                            );
                            if (itemIndex === -1) {
                              copy.push({
                                uuid: item.uuid,
                                quantity: value,
                                pieces: "",
                              });
                            } else {
                              copy[itemIndex].quantity = value;
                            }

                            setInputFields(copy);
                            const copySelectedRows = JSON.parse(
                              JSON.stringify(selectedRows)
                            );
                            copySelectedRows.forEach((ite: any) => {
                              const index = copy.findIndex(
                                (it: any) => it.uuid === ite.uuid
                              );
                              ite.quantity = copy[index].quantity;
                              ite.pieces = copy[index].pieces;
                            });
                            setSelectedRows(copySelectedRows);
                          }}
                        >
                          (返修)本次组数:
                        </InputItem>
                        <InputItem
                          style={{ marginLeft: -6, textAlign: "left" }}
                          id={item.uuid + "pieces"}
                          min={0}
                          type={"digit"}
                          placeholder={"请填写"}
                          value={
                            inputFields[
                              inputFields.findIndex(
                                (it) => it.uuid === item.uuid
                              )
                            ]?.pieces
                          }
                          onChange={(value) => {
                            // 输入框填写工作量时 要同步到已选项
                            const copy = JSON.parse(
                              JSON.stringify(inputFields)
                            );
                            const itemIndex = copy.findIndex(
                              (it: any) => it.uuid === item.uuid
                            );
                            if (itemIndex === -1) {
                              copy.push({
                                uuid: item.uuid,
                                quantity: "",
                                pieces: value,
                              });
                            } else {
                              copy[itemIndex].pieces = value;
                            }

                            setInputFields(copy);
                            const copySelectedRows = JSON.parse(
                              JSON.stringify(selectedRows)
                            );
                            copySelectedRows.forEach((ite: any) => {
                              const index = copy.findIndex(
                                (it: any) => it.uuid === ite.uuid
                              );
                              ite.quantity = copy[index].quantity;
                              ite.pieces = copy[index].pieces;
                            });
                            setSelectedRows(copySelectedRows);
                          }}
                        >
                          (返修)本次柱/档数:
                        </InputItem>
                      </div>
                    </>
                  )}
                </Item>
              </CheckboxItem>
            ))}
        </List>
      </>
    );
  }
);

export default WorkDataList;
